@if (event?.description || tags.length > 0) {
<section class="eventsection-details__info">
  @if (event?.description) {
  <div class="mdc-layout-grid">
    <div class="mdc-layout-grid__inner">
      <div
        class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
        <planone-expandable-text
          [text]="event?.description | TransformLinefeed | WYSIWYGTagFilter"
          backgroundColor="255, 255, 255"></planone-expandable-text>
        @if (event?.language) {
        <div class="eventsection-details__language" i18n="@@featureEventDetails-languageDetails"
          >Sprache des Events: {{ event?.language }}
        </div>
        }
      </div>
    </div>
  </div>
  } @if (tags.length > 0) {
  <div class="mdc-layout-grid eventsection-details__flowsection">
    <div class="mdc-layout-grid__inner">
      <div
        class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
        <planone-expandable-chip-list
          [fairId]="event?.fair_id"
          [chips]="tags"
          [threshold]="8"
          [chipsListClickable]="chipsListClickable"></planone-expandable-chip-list>
      </div>
    </div>
  </div>
  }
</section>
}
